import React, { useState, useEffect } from "react";
import { AlertTriangle, X, Mail } from "lucide-react";

const STORAGE_KEY = "sal_beta_banner_dismissed";

export const BetaBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) setVisible(true);
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(STORAGE_KEY, "1");
  };

  if (!visible) return null;

  return (
    <div
      data-testid="beta-banner"
      className="relative z-[60] bg-brand-surface border-b border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 text-xs text-brand-silver">
          <AlertTriangle size={14} className="text-brand-platinum shrink-0" />
          <span className="tracking-wide">
            <span className="text-brand-platinum tracking-widest2 uppercase mr-2">Beta —</span>
            Website under construction. You may find occasional errors. For any question, please write to
            <a
              href="mailto:info@swissalpenline.ch"
              className="ml-1 text-brand-platinum underline hover:text-white inline-flex items-center gap-1"
              data-testid="banner-email-link"
            >
              <Mail size={12} /> info@swissalpenline.ch
            </a>.
          </span>
        </div>
        <button
          onClick={dismiss}
          data-testid="banner-dismiss"
          aria-label="Dismiss"
          className="text-brand-silver hover:text-brand-platinum transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default BetaBanner;
